/**
 * 쌓인 메모 목록 — styled (D-41).
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 */
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Item = styled.li`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
`;

export const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
`;

export const Author = styled.span`
  font-weight: 600;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
`;

export const VersionTag = styled.span`
  padding: 1px 6px;
  border-radius: 4px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
`;

export const Body = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  white-space: pre-wrap;
  word-break: break-word;
`;

export const LogLink = styled.a`
  align-self: flex-start;
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Blue")?.[500]};
  text-decoration: underline;
`;

export const StateText = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
`;

export const ErrorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
